// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"styles__formLabel___2bpJY","input":"styles__input___vjV_8","select":"styles__select___ADT9n styles__input___vjV_8"};